import {
  DrawerContent,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
} from "@chakra-ui/react";
import DrawerFormFooter from "components/Shared/DrawerForm/DrawerFormFooter";
import Form, { FormFields } from "./Form";
import useCreateDistributionCenter, {
  MutationResult,
} from "./useCreateDistributionCenter";

const FORM_ID = "create-distribution-center-form";

type Props = {
  defaultValues?: Partial<FormFields>;
  formId?: string;
  isAdmin?: boolean;
  metadata?: GraphQLJSON;
  onCancel: () => void;
  onCompleted: (data: MutationResult) => void;
  orderingPlatformId?: UUID;
};

export function CreateDrawerContentInner({
  defaultValues,
  formId = FORM_ID,
  isAdmin,
  metadata,
  onCancel,
  onCompleted,
  orderingPlatformId,
}: Props) {
  const { handleValidSubmit, isUpdating } = useCreateDistributionCenter({
    isAdmin,
    metadata,
    onCompleted,
  });

  return (
    <>
      <DrawerBody>
        <Form
          autoFocus
          defaultValues={defaultValues}
          onValidSubmit={handleValidSubmit}
          id={formId}
          isAdmin={isAdmin}
          orderingPlatformId={orderingPlatformId}
        />
      </DrawerBody>

      <DrawerFormFooter
        onClose={onCancel}
        formId={formId}
        submitButtonProps={{ isLoading: isUpdating }}
      />
    </>
  );
}

export default function CreateDrawerContent(props: Props) {
  return (
    <DrawerContent bg="cardBackground">
      <DrawerCloseButton />
      <DrawerHeader>Create Distribution Center</DrawerHeader>
      <CreateDrawerContentInner {...props} />
    </DrawerContent>
  );
}
